import type { TRuleWithTheme } from '@/styles/theme';

export const option: TRuleWithTheme = ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '18px auto',
    alignItems: 'center',
    columnGap: theme.spacing(8),

    '&.ant-select-item-option': {
        padding: '0.5rem 1rem',
        fontWeight: 500,
        fontFamily: theme.fontFamily,
        color: theme.colors.black,
        fontSize: '0.875rem',
        lineHeight: '1.5rem',
    },

    '&.ant-select-item-option.ant-select-item-option-selected': {
        backgroundColor: theme.colors.paleMauve,
        color: theme.colors.black,

        fontWeight: 500,
    },

    '&.ant-select-item-option.ant-select-item-option-active': {
        backgroundColor: theme.colors.white,
        color: theme.colors.blue,
    },

    '&.ant-select-item-option.ant-select-item-option-active.ant-select-item-option-selected': {
        backgroundColor: theme.colors.paleMauve,
        color: theme.colors.black,
    },
});

export const empty: TRuleWithTheme = ({ theme }) => ({
    width: 18,
});
